module.exports = __webpack_public_path__ + "assets/img/lawyer.7988f8ca.png";